import {isNumber} from 'utils/IsNumber.js';
import {toggleStep} from 'operations/actions.js';
import {word} from './commands/word.js';
import {deleteNextWord, deleteAtCursor, deleteLine} from './commands/delete.js';
import {increaseDuration, decreaseDuration} from './commands/step.js';
import {goToStartOfLine, upLine, downLine} from './commands/line.js';
import {pasteKillRing} from './commands/paste.js';
import {yankLine, yankNextWord} from './commands/yank.js';

/**
 * Implements vim-style keybindings for step editing
 */
class ViScripting {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        this.cursor = sequencerEngine.cursor;

        this.currentCommand = undefined;
        this.number = undefined;

        this.killRing = [];

        this['0'] = () => {
            this.zero();
        };
    }

    run(key) {
        if (key in this) {
            if (this.currentCommand && this.number) {
                this[key](parseInt(this.number));
                this.number = undefined;
                this.currentCommand = undefined;
            } else {
                this[key]();
                this.currentCommand = key;
            }
        }
        if (isNumber(key)) {
            if (this.number === undefined) {
                this.number = '';
            }
            this.number += key;
        }
    }

    d(n) {
        // dwd deletes the next word dd deletes the current line
        n = n === undefined ? 1 : n;
        if (this.currentCommand == 'd') {
            // delete this line
            this.killRing = [];
            for (let i=0; i < n; i++) {
                this.killRing = [
                    ...this.killRing,
                    ...deleteLine(this.sequencerEngine)];
                downLine(this.sequencerEngine, false);
            }
            for (let i=0; i < n; i++) {
                upLine(this.sequencerEngine, false);
            }
            this.updateRedux();
            this.currentCommand = undefined;
        }
    }

    x() {
        this.killRing = deleteAtCursor(this.sequencerEngine);
    }

    w(n) {
        if (this.currentCommand == 'd') {
            n = n === undefined ? 1 : n;
            this.killRing = [];
            for (let i=0 ; i < n; i++) {
                this.killRing = [
                    ... this.killRing,
                    ...deleteNextWord(this.sequencerEngine)];
            }
            this.currentCommand = undefined;
            return;
        } else if (this.currentCommand == 'y') {
            n = n === undefined ? 1 : n;
            this.killRing = [];
            for (let i=0 ; i < n; i++) {
                this.killRing = [
                    ... this.killRing,
                    ...yankNextWord(this.sequencerEngine)];
            }
            this.currentCommand = undefined;
            return;
        }

        n = n === undefined ? 1 : n - 1;
        for (let i=0 ; i < n; i++) {
            word(true, this.sequencerEngine);
        }
    }

    b(n) {
        n = n === undefined ? 1 : n - 1;
        for (let i=0 ; i < n; i++) {
            word(false, this.sequencerEngine);
        }
    }

    h() {
        this.sequencerEngine.left();
    }

    l() {
        this.sequencerEngine.right();
    }

    j() {
        downLine(this.sequencerEngine);
    }

    k() {
        upLine(this.sequencerEngine);
    }

    // toggle
    t() {
        this.dispatch(
            toggleStep(this.track, this.stepNumber, this.resolution));
    }

    // edit
    e() {
        this.cursor.show = !this.cursor.show;
    }

    zero() {
        goToStartOfLine(this.sequencerEngine);
    }

    a() {
        this.track.doubleTrackLength();
    }

    s() {
        this.track.halfTrackLength();
    }

    o() {
        increaseDuration(this.sequencerEngine);
    }

    i() {
        decreaseDuration(this.sequencerEngine);
    }

    y(n) {
        n = n === undefined ? 1 : n;
        if (this.currentCommand == 'y') {
            this.killRing = [];
            for (let i=0; i < n; i++) {
                this.killRing = [
                    ...this.killRing,
                    ...yankLine(this.sequencerEngine)];
                downLine(this.sequencerEngine, false);
            }
            for (let i=0; i < n; i++) {
                upLine(this.sequencerEngine, false);
            }
            this.updateRedux();
            this.currentCommand = undefined;
        }
    }

    p() {
        pasteKillRing(this.sequencerEngine, [...this.killRing]);
    }

    get stepNumber() {
        return this.sequencerEngine.getSelectedStep();
    }

    get track() {
        return this.sequencerEngine.getSelectedTrack();
    }

    get op() {
        return this.sequencerEngine.operationManager;
    }

    dispatch(e) {
        this.op.dispatch(e);
    }

    get resolution() {
        return this.sequencerEngine.resolution;
    }

    updateRedux() {
        this.cursor.updateRedux();
    }
}

export default ViScripting;
